import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import PostSPCard from './PostSPCard';

const PostSP = () => {
    const { postUrl } = useParams();
    const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;

    const url = useMemo(() => `${baseUrl}/content/post/${postUrl}`, [baseUrl, postUrl]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [page, setPage] = useState([]);
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    fetch(url, {
      method: 'GET',
      headers: requestHeaders
      })
      .then(async (response) => {
        if (!response.ok) {
          if (response.status === 404) {
            setPage({ok: false, conteudo: "Página não encontrada" });
            setLoading(false);
            return;
          }
          console.error("Erro ao buscar a página:", response.statusText);
          setPage({ok: false, conteudo: "Erro ao buscar a página" });
          return
        }
        setPage({ok: true, conteudo: await response.json()});
        setLoading(false);
      });
  }, [isLoading, url, requestHeaders]);
  if (isLoading) {
    return <CircularProgress className="loading" />;
  }

  return (
    <div>
        {page.ok ? <PostSPCard postObject={page.conteudo} location="completo"/> : <div className="post maincontent">
        <h2 style={{textAlign: "center"}}>{page.conteudo}</h2>
        </div>}
    </div>
  );
};

export default PostSP;

